export const EMPLOYER_USER_TYPE = 2;

export const EMPLOYER_SIZE_OPTIONS = [
  { key: "0-10", text: "0-10", value: "0-10" },
  { key: "10-500", text: "10-500", value: "10-500" },
  { key: "500-1000", text: " 500-1000", value: "500-1000" },
  { key: "1000-3000", text: "1000-3000", value: "1000-3000" },
  { key: "3000-10000", text: "3000-10000", value: "3000-10000" },
  { key: ">10000", text: ">10000", value: ">10000" },
];
